"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _mobxReact = require("mobx-react");
var _styled = _interopRequireDefault(require("@emotion/styled"));
var _icon_wrapper = _interopRequireDefault(require("./icon_wrapper"));
var _templateObject, _class, _FlagTlIcon;
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _taggedTemplateLiteral(e, t) { return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } })); }
var Wrapper = _styled["default"].div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  border-radius: 50%;\n  display: inline-block;\n  overflow: hidden;\n  width: ", ";\n  height: ", ";\n"])), function (props) {
  return props.width;
}, function (props) {
  return props.width;
});
var FlagTlIcon = (0, _mobxReact.observer)(_class = (_FlagTlIcon = /*#__PURE__*/function (_React$Component) {
  function FlagTlIcon() {
    _classCallCheck(this, FlagTlIcon);
    return _callSuper(this, FlagTlIcon, arguments);
  }
  _inherits(FlagTlIcon, _React$Component);
  return _createClass(FlagTlIcon, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/_react["default"].createElement(Wrapper, {
        width: this.props.width
      }, /*#__PURE__*/_react["default"].createElement("svg", {
        viewBox: "0 0 100 100",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg"
      }, /*#__PURE__*/_react["default"].createElement("g", null, /*#__PURE__*/_react["default"].createElement("rect", {
        id: "Rectangle",
        fill: "#0038A8",
        x: "0",
        y: "0",
        width: "100",
        height: "50"
      }), /*#__PURE__*/_react["default"].createElement("rect", {
        id: "Rectangle",
        fill: "#CE1126",
        x: "0",
        y: "50",
        width: "100",
        height: "50"
      }), /*#__PURE__*/_react["default"].createElement("polygon", {
        id: "Path",
        fill: "#FFFFFF",
        points: "0 0 80 50 0 100"
      }), /*#__PURE__*/_react["default"].createElement("g", {
        id: "Group",
        transform: "translate(14.000000, 19.000000)",
        fill: "#FCD116"
      }, /*#__PURE__*/_react["default"].createElement("polygon", {
        id: "Path",
        points: "2.5 0.4 4.7 2.3 7.2 0.8 6.1 3.6 8.3 5.6 5.3 5.3 4.1 8 3.4 5.1 0.5 4.8 3 3.2"
      }), /*#__PURE__*/_react["default"].createElement("polygon", {
        id: "Path",
        points: "4.1 54 5.3 56.7 8.3 56.4 6.1 58.5 7.3 61.2 4.7 59.7 2.5 61.6 3 58.7 0.5 57.2 3.4 56.9"
      }), /*#__PURE__*/_react["default"].createElement("polygon", {
        id: "Path",
        points: "52.7 27.1 52.7 30 55.5 31 52.7 32 52.7 34.9 50.9 32.5 48.1 33.4 49.8 30.9 48.1 28.6 50.9 29.4"
      }), /*#__PURE__*/_react["default"].createElement("circle", {
        id: "Oval",
        cx: "21.8",
        cy: "30.9",
        r: "7.2"
      }), /*#__PURE__*/_react["default"].createElement("g", {
        transform: "translate(19.000000, 15.000000)",
        id: "Path"
      }, /*#__PURE__*/_react["default"].createElement("polygon", {
        points: "0.2 2.7 1 2 1.8 9.2 1.3 9.2"
      }), /*#__PURE__*/_react["default"].createElement("polygon", {
        points: "4.6 2 3.7 9.2 4.2 9.2 5.4 2.7"
      }), /*#__PURE__*/_react["default"].createElement("polygon", {
        points: "2.8 0.4 1.9 1.2 2.4 9.2 3.1 9.2 3.7 1.3"
      })), /*#__PURE__*/_react["default"].createElement("g", {
        transform: "translate(19.000000, 37.000000)",
        id: "Path"
      }, /*#__PURE__*/_react["default"].createElement("polygon", {
        points: "0.2 7 1 7.8 1.8 0.5 1.3 0.5"
      }), /*#__PURE__*/_react["default"].createElement("polygon", {
        points: "4.6 7.7 3.7 0.5 4.2 0.5 5.4 7.1"
      }), /*#__PURE__*/_react["default"].createElement("polygon", {
        points: "2.8 9.4 1.9 8.5 2.4 0.5 3.1 0.5 3.7 8.5"
      })), /*#__PURE__*/_react["default"].createElement("g", {
        transform: "translate(28.000000, 28.000000)",
        id: "Path"
      }, /*#__PURE__*/_react["default"].createElement("polygon", {
        points: "7 0.3 7.7 1 0.5 1.9 0.5 1.4"
      }), /*#__PURE__*/_react["default"].createElement("polygon", {
        points: "7.7 4.7 0.5 3.8 0.5 4.2 7 5.5"
      }), /*#__PURE__*/_react["default"].createElement("polygon", {
        points: "9.3 2.9 8.4 1.9 0.5 2.4 0.5 3.2 8.4 3.8"
      })), /*#__PURE__*/_react["default"].createElement("g", {
        transform: "translate(6.000000, 28.000000)",
        id: "Path"
      }, /*#__PURE__*/_react["default"].createElement("polygon", {
        points: "2.7 0.3 1.9 1 9.2 1.9 9.2 1.4"
      }), /*#__PURE__*/_react["default"].createElement("polygon", {
        points: "2 4.7 9.2 3.8 9.2 4.2 2.6 5.5"
      }), /*#__PURE__*/_react["default"].createElement("polygon", {
        points: "0.3 2.9 1.2 1.9 9.2 2.4 9.2 3.2 1.2 3.8"
      })), /*#__PURE__*/_react["default"].createElement("g", {
        transform: "translate(25.000000, 34.000000)",
        id: "Path"
      }, /*#__PURE__*/_react["default"].createElement("polygon", {
        points: "8 4.3 8 5.4 2.2 0.9 2.6 0.5"
      }), /*#__PURE__*/_react["default"].createElement("polygon", {
        points: "5.3 8 0.9 2.2 0.6 2.6 4.3 8.1"
      }), /*#__PURE__*/_react["default"].createElement("polygon", {
        points: "7.8 7.8 7.8 6.6 1.8 1.3 1.3 1.8 6.5 7.9"
      })), /*#__PURE__*/_react["default"].createElement("g", {
        transform: "translate(10.000000, 19.000000)",
        id: "Path"
      }, /*#__PURE__*/_react["default"].createElement("polygon", {
        points: "4.4 0.7 3.3 0.7 7.8 6.5 8.2 6.1"
      }), /*#__PURE__*/_react["default"].createElement("polygon", {
        points: "0.7 3.4 6.4 7.8 6.1 8.1 0.6 4.4"
      }), /*#__PURE__*/_react["default"].createElement("polygon", {
        points: "0.9 0.9 2.1 0.9 7.4 6.8 6.9 7.4 0.8 2.2"
      })), /*#__PURE__*/_react["default"].createElement("g", {
        transform: "translate(25.000000, 19.000000)",
        id: "Path"
      }, /*#__PURE__*/_react["default"].createElement("polygon", {
        points: "4.3 0.7 5.3 0.7 0.8 6.5 0.5 6.1"
      }), /*#__PURE__*/_react["default"].createElement("polygon", {
        points: "7.9 3.4 2.2 7.8 2.5 8.1 8 4.4"
      }), /*#__PURE__*/_react["default"].createElement("polygon", {
        points: "7.8 0.9 6.5 0.9 1.2 6.8 1.8 7.4 7.8 2.2"
      })), /*#__PURE__*/_react["default"].createElement("g", {
        transform: "translate(10.000000, 34.000000)",
        id: "Path"
      }, /*#__PURE__*/_react["default"].createElement("polygon", {
        points: "0.7 4.3 0.7 5.4 6.4 0.9 6 0.5"
      }), /*#__PURE__*/_react["default"].createElement("polygon", {
        points: "3.3 8 7.8 2.2 8.1 2.6 4.4 8.1"
      }), /*#__PURE__*/_react["default"].createElement("polygon", {
        points: "0.8 7.8 0.8 6.6 6.8 1.3 7.3 1.8 2.2 7.9"
      }))))));
    }
  }]);
}(_react["default"].Component), _FlagTlIcon.defaultProps = {
  width: '20px'
}, _FlagTlIcon)) || _class;
var _default = exports["default"] = (0, _icon_wrapper["default"])(FlagTlIcon);